module.exports = __webpack_public_path__ + "img/权益背景.ba7ece5b.jpg";